/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { CustomButtonProps } from "./interface";
import { customButtonStyles } from "./styles";

export const CustomButton: React.FunctionComponent<CustomButtonProps> = (
  props
) => {
  return (
    <button
      type={props.type}
      disabled={props.disabled || false}
      className={`custom-button ${props.className ? props.className : ""}`}
      style={props.style}
      onClick={(e) => {
        props.onClick && props.onClick(e);
      }}
      css={customButtonStyles(props.disabled ? "disabled" : props.color)}
    >
      {props.children}
    </button>
  );
};
